import { RouteObject } from "react-router-dom";
import { DevelopmentDropsPage } from "src/routes/developments/drops/DevelopmentDropsPage";
import { LotSummaryPage } from "src/routes/developments/lot-summary/LotSummaryPage";
import { DevelopmentTeamMembers } from "src/routes/developments/team-members/DevelopmentTeamMembers";
import { DevelopmentDocumentsPage } from "src/routes/projects/documents/DocumentsPage";
import { JobLogsPage } from "src/routes/projects/job-logs/JobLogsPage";
import * as overviewPaths from "src/routing/domains/developments/overview/overviewPaths";

/**
 * SideNav leaf routes for development overview section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in
 * `detail/developmentDetail.tsx`. Documents lives on the Beam branch
 * (`overviewBeamSideNavRoutes`).
 */
export const overviewSideNavRoutes: RouteObject[] = [
  { path: `${overviewPaths.developmentLotSummaryRoute.path}/*`, Component: LotSummaryPage },
  { path: overviewPaths.developmentTeamRoute.path, Component: DevelopmentTeamMembers },
  { path: overviewPaths.developmentDropsRoute.path, Component: DevelopmentDropsPage },
  { path: `${overviewPaths.developmentJobLogsRoute.path}/*`, Component: JobLogsPage },
];

/**
 * Overview leaves that have migrated to Beam's SideNavLayout and document-scroll page layouts.
 *
 * Role: data router domain leaves. Spread under `DevelopmentBeamSideNavLayout` in
 * `detail/developmentDetail.tsx`.
 */
export const overviewBeamSideNavRoutes: RouteObject[] = [
  { path: overviewPaths.developmentDocumentsRoute.path, Component: DevelopmentDocumentsPage },
];
